import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import BookPage from "@/pages/BookPage";
import AdminPage from "@/pages/AdminPage";
import ServicePage from "@/pages/ServicePage";
import PropertyDemo from "@/pages/PropertyDemo";
import GolfDemo from "@/pages/GolfDemo";
import AppDemo from "@/pages/AppDemo";

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    }, [pathname]);
    return null;
}

function LenisRoot() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <LenisRoot />
            <ScrollManager />
            <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid rgba(255,255,255,0.12)", color: "#fff" } }} />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/book" element={<BookPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route path="/demos/property" element={<PropertyDemo />} />
                <Route path="/demos/golf" element={<GolfDemo />} />
                <Route path="/demos/app/:appId" element={<AppDemo />} />
                <Route path="*" element={<HomePage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
